export const GlobalImage = {
  logo: require("../assets/images/silversky/logo.png"),
  businessProfile: require("../assets/images/silversky/businessProfile.png"),
  subscriptionVector: require("../assets/images/silversky/subscriptionVector.png"),
  businessImagePlaceholder: require("../assets/images/silversky/businessImagePlaceholder.png"),
  triColor: require("../assets/images/silversky/triColor.png"),
  pfp: require("../assets/images/silversky/PFP.png"),
  userPlaceHolder: require("../assets/images/users/userPlaceHolder.png"),
  dummySignature: require("../assets/images/dummy/dummySignature.png"),
  camera: require("../assets/images/dummy/camera.png"),
  successTick: require("../assets/images/silversky/successTick.png"),
};
